import React, { Component } from "react";
// import L from 'leaflet'
// import { MapContainer, TileLayer, Marker, Popup, useMapEvents, GeoJSON } from 'react-leaflet'
// import 'leaflet-rotatedmarker'
import JSONLand_Far from '../geojson/moriarty-hand-large-land.json'
import JSONLand_VeryFar from '../geojson/moriarty-hand-small-land.json'
import JSONLand_Close from '../geojson/ne_50m_land.json'
import JSONLand_VeryClose from '../geojson/ne_10m_land.json'
import JSONMinorIslands from '../geojson/ne_10m_minor_islands.json'
// import JSONLand_Close from '../geojson/earth-coastlines-250m.geo.json'
import JSONOcean from '../geojson/ne_10m_wgs84_bounding_box.json'
import JSONmarine from '../geojson/ne_10m_geography_marine_centroids.json'

import "leaflet/dist/leaflet.css"
import '../css/navigationMap.css';

var L = null

class NavigationMap extends Component {
    constructor(props) {
        super(props);

        this.toggleWinds = this.toggleWinds.bind(this);
        this.toggleLogs = this.toggleLogs.bind(this);
        this.toggleCurrents = this.toggleCurrents.bind(this);

        this.state = {
            showWind: true,
            showLogs: true,
            showCurrents: false,
            logPoints: []
        };
    }
    componentDidMount() {
        L = require("leaflet")
        require("leaflet-graticule")
        require("leaflet-swoopy")

        var myStyle = {
            "fill": "red",
            "stroke": "yellow",
            "weight": 2,
            "opacity": 1,
            "fillOpacity": 1
        };

        // map.createPane('geo');
        const land_lvl_1_Layer = L.geoJSON(JSONLand_VeryFar, {
            className: 'navMapLand',
            style: myStyle
        });
        const land_lvl_2_Layer = L.geoJSON(JSONLand_Far, {
            className: 'navMapLand',
            style: myStyle
        });
        const land_lvl_3_Layer = L.geoJSON(JSONLand_Close, {
            className: 'navMapLand',
            style: myStyle
        });
        const veryClose_Layer = L.geoJSON(JSONLand_VeryClose, {
            className: 'navMapLand',
            style: myStyle
        });
        const minorIslands_Layer = L.geoJSON(JSONMinorIslands, {
            className: 'navMapLand',
            style: myStyle
        });
        const land_lvl_4_Layer = L.layerGroup([veryClose_Layer, minorIslands_Layer]);

        const oceanLayer = L.geoJSON(JSONOcean, {
            className: 'navMapOcean',
            style: myStyle
        });



        // L.tileLayer('http://{s}.tile.stamen.com/toner-lite/{z}/{x}/{y}.png', {
        //     maxZoom: 5
        // }).addTo(map)

        const map = L.map('leafletNavMap', {
            attribution: "&copy; Shapefiles by Dylan Moriarty & Natural Earth",
            layers: [oceanLayer, land_lvl_2_Layer],
            maxZoom: 11,
            minZoom: 2,
            zoomSnap: 0.5,
        }).setView([0, 0], 3);


        // SEA LABELS
        const labelGroup_0 = L.layerGroup([])
            .addTo(map);
        const labelGroup_1 = L.layerGroup([]);
        const labelGroup_2 = L.layerGroup([]);
        const labelGroup_3 = L.layerGroup([]);
        const labelGroup_4 = L.layerGroup([]);
        const labelGroup_5 = L.layerGroup([]);
        const labelGroup_6 = L.layerGroup([]);
        const labelGroup_7 = L.layerGroup([]);
        const labelGroup_8 = L.layerGroup([]);
        const labelGroup_9 = L.layerGroup([]);


        const onEachFeature = function (feature, layer) {
            if (feature.properties.name_fr != null && feature.properties.featurecla !== 'river') {
                const labelMarker = L.marker([feature.geometry.coordinates[1], feature.geometry.coordinates[0]], {
                    opacity: 0
                }).bindTooltip(feature.properties.name_fr, {
                    className: 'seaLabel_' + feature.properties.scalerank,
                    permanent: true,
                    direction: 'bottom'
                });

                if (feature.properties.scalerank === 0) {
                    labelGroup_0.addLayer(labelMarker);
                } else if (feature.properties.scalerank === 1) {
                    labelGroup_1.addLayer(labelMarker);
                } else if (feature.properties.scalerank === 2) {
                    labelGroup_2.addLayer(labelMarker);
                } else if (feature.properties.scalerank === 3) {
                    labelGroup_3.addLayer(labelMarker);
                } else if (feature.properties.scalerank === 4) {
                    labelGroup_4.addLayer(labelMarker);
                } else if (feature.properties.scalerank === 5) {
                    labelGroup_5.addLayer(labelMarker);
                } else if (feature.properties.scalerank === 6) {
                    labelGroup_6.addLayer(labelMarker);
                } else if (feature.properties.scalerank === 7) {
                    labelGroup_7.addLayer(labelMarker);
                } else if (feature.properties.scalerank === 8) {
                    labelGroup_8.addLayer(labelMarker);
                } else if (feature.properties.scalerank === 9) {
                    labelGroup_9.addLayer(labelMarker);
                }
            }
        }
        L.geoJSON(JSONmarine, {
            className: 'navMapSeaPoly',
            onEachFeature: onEachFeature,
        })
        // END SEA LABELS

        // WINDS
        const windArrowColor = "#473e34";
        const windArrowWeight = 2
        const windGroup = L.layerGroup([]);
        const winds = [];
        let i = 0;
        // Trade winds Afrique -> Amérique
        winds[i] = L.swoopyArrow([20.5, -43], [13, -61], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([16, -20], [7, -47], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Westerlies Amérique -> Europe
        winds[i] = L.swoopyArrow([38, -58], [49, -11], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([56, -77], [58, -47], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([47, -68], [54, -32], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Entre trade winds et westerlies
        winds[i] = L.swoopyArrow([41, -34], [21, -39], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: 1.7,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([22, -57], [36, -62], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: 2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Sud Afrique -> Amérique
        winds[i] = L.swoopyArrow([-16, 6], [-7, -16], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-17, -7], [-12, -32], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-16, -26], [-29, -34], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -1,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Antarctique
        winds[i] = L.swoopyArrow([-54, -77], [-48, 8], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-47, -67], [-37, -37], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-42, 18], [-45, 71], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-62, -16], [-53, 41], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-42, -12], [-24, -1], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -1,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-56, 68], [-47, 132], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.4,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-46, -111], [-23, -83], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -1,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-58, -168], [-51, -93], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-38, -173], [-46, -132], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-54, 129], [-52, 172], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Océan Indien -> Antarctique
        winds[i] = L.swoopyArrow([-13, 56], [-37, 62], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -1,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-38, 86], [-16, 91], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -1,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Océan Indien : Océanie -> Afrique
        winds[i] = L.swoopyArrow([-12, 87], [-6, 48], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.5,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-18, 119], [-12, 93], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-10, 147], [-4, 117], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Océan Indien northeasterlies
        winds[i] = L.swoopyArrow([16.5, 73], [4, 52], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .3,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([9, 83], [-4, 87], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.5,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Pacific trade winds : East
        winds[i] = L.swoopyArrow([16, 137], [6, 111], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([32, 173], [29, 127], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([3, 177], [6, 142], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Pacific trade winds : West
        winds[i] = L.swoopyArrow([-11, -89], [6.5, -141], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.4,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([-14, -123], [-3.5, -167], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([17, -113], [13, -156], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Pacific Westerlies
        winds[i] = L.swoopyArrow([42, -171], [48, -131], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([48, 149], [54, 173], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: .2,
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        // Mediterranean
        winds[i] = L.swoopyArrow([43.5, 2.5], [41.3, 6.2], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2, // Mistral
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([39.2, 26.2], [35.8, 24.8], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2, // Egee
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([44.9, 16.5], [41.2, 17.6], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2, // Bora
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;
        winds[i] = L.swoopyArrow([31.3, 12.9], [34.9, 15.6], {
            color: windArrowColor,
            weight: windArrowWeight,
            factor: -.2, // Sirocco
            iconAnchor: [20, 10],
            iconSize: [20, 16]
        }); i++;

        for (let j = 0; j < winds.length; j++) {
            windGroup.addLayer(winds[j]);
        }
        // END WINDS

        const logPointsGroup = L.layerGroup([])
            .addTo(map);

        const boundMapZoomHandler = this.mapZoomHandler.bind(this);
        map.addEventListener('zoom', boundMapZoomHandler);



        L.latlngGraticule({
            showLabel: true,
            dashArray: [5, 5],
            color: "#93886c7a",
            font: '12px Quattrocento',
            sides: [' N', ' S', ' E', ' O'],
            weight: 2,
            zoomInterval: [
                { start: 2, end: 3, interval: 30 },
                { start: 4, end: 4, interval: 10 },
                { start: 5, end: 7, interval: 5 },
                { start: 8, end: 10, interval: 1 }
            ]
        }).addTo(map);


        const logIcon = L.icon({
            iconUrl: '../img/logIcon.png',
            iconSize: [16, 16],
            iconAnchor: [8, 8],
            popupAnchor: [0, 0]
        })
        // const defs = '';

        // document.getElementsByClassName('leaflet-overlay-pane')[0].firstChild.innerHTML += defs;
        // console.log(document.getElementsByClassName('leaflet-overlay-pane')[0].firstChild);

        this.setState({
            navigationMap: map,
            land_lvl_1_Layer: land_lvl_1_Layer,
            land_lvl_2_Layer: land_lvl_2_Layer,
            land_lvl_3_Layer: land_lvl_3_Layer,
            land_lvl_4_Layer: land_lvl_4_Layer,
            labelGroup_0: labelGroup_0,
            labelGroup_1: labelGroup_1,
            labelGroup_2: labelGroup_2,
            labelGroup_3: labelGroup_3,
            labelGroup_4: labelGroup_4,
            labelGroup_5: labelGroup_5,
            labelGroup_6: labelGroup_6,
            labelGroup_7: labelGroup_7,
            labelGroup_8: labelGroup_8,
            labelGroup_9: labelGroup_9,
            logIcon: logIcon,
            logPointsGroup: logPointsGroup,
            windLayer: windGroup,
            // currentsLayer: currentsLayer,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.logs && this.props.logs !== prevProps.logs) {

            let prevLogCoords = null;

            for (let i = 0; i < this.props.logs.length; i++) {
                const element = this.props.logs[i];
                if (!this.state.logPoints[element.timestamp_UTC]) { // If point not already on map
                    if (element.lat !== '?' && element.long !== '?') {//If coords associated
                        // Compute local date from log point
                        let date = new Date(element.timestamp_UTC + element.timeOffset * 1000 * 60);
                        let comment = element.content;
                        const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
                        const optionsTime = { hour: '2-digit', minute: '2-digit' };
                        comment = comment.replace('\n', '<br />');
                        console.log(element)
                        const popupContent = '<i>' + date.toLocaleDateString('fr-FR', options) + ' (' + date.toLocaleTimeString('fr-FR', optionsTime) + ')</i><br /><b>' + parseFloat(element.lat).toFixed(2) + ', ' + parseFloat(element.long).toFixed(2) + '</b><br /><span class=popupLogText>' + comment + '</span>';



                        const popup = L.popup({
                            className: 'popup',
                            closeButton: false,
                            minWidth: 300
                        }).setContent(popupContent);

                        const marker = L.marker([element.lat, element.long], {
                            title: date.toLocaleDateString('fr-FR', options) + ' (' + date.toLocaleTimeString('fr-FR') + ') : ' + parseFloat(element.lat).toFixed(2) + ', ' + parseFloat(element.long).toFixed(2),
                            icon: this.state.logIcon
                        }).addTo(this.state.navigationMap).bindPopup(popup);

                        let logPointsGroup = this.state.logPointsGroup;
                        logPointsGroup.addLayer(marker);
                        this.setState({ logPointsGroup: logPointsGroup })


                        let newState = this.state.logPoints;
                        newState[element.timestamp_UTC] = true;
                        this.setState({ logPoints: newState })


                        if (prevLogCoords) {
                            L.swoopyArrow(prevLogCoords, [element.lat, element.long], {
                                color: '#939184',
                                weight: 2,
                                factor: 0,
                                iconAnchor: [20, 10],
                                iconSize: [20, 16],
                                hideArrowHead: true
                            }).addTo(this.state.navigationMap);
                        }
                        prevLogCoords = [element.lat, element.long];
                    }
                }
            }
        }
    }

    render() {
        return <div id="navigationMap" >
            <div id="leafletNavMap" className="navigationMap" />
            <div className="layerControl">
                <h2 className="Title">Carte du monde</h2>
                <span className={this.state.showLogs ? 'layerEnabled' : 'layerDisabled'} onClick={this.toggleLogs}>Afficher les entrées du journal</span><br />
                <span className={this.state.showWinds ? 'layerEnabled' : 'layerDisabled'} onClick={this.toggleWinds}>Afficher les vents dominants</span><br />
                <span className={this.state.showCurrents ? 'layerEnabled' : 'layerDisabled'} onClick={this.toggleCurrents}>Afficher les courants</span>
            </div>
            <svg>
                <def id="defs">
                    <pattern id="oceanPattern" width="100" height="20" patternUnits="userSpaceOnUse">
                        <rect fill="#f9f1e8" x="0" width="100" height="20" y="0"></rect>
                        <path d="M21.1841339,20 C21.5411448,19.869748 21.9037256,19.7358773 22.272392,19.5983261 C22.6346445,19.4631679 23.8705367,18.9999982 24.0399055,18.9366758 C33.6397477,15.3475548 39.6469349,14 50,14 C60.2711361,14 65.3618399,15.2217689 74.6286093,18.9284767 C75.584355,19.310775 76.4978747,19.6675274 77.3787841,20 L83.604005,20 C81.0931362,19.2694473 78.4649665,18.3089537 75.3713907,17.0715233 C65.8881601,13.2782311 60.5621972,12 50,12 C39.3741437,12 33.144814,13.3973866 23.3395101,17.0633242 C23.1688625,17.1271247 21.9338538,17.5899633 21.5732596,17.7245028 C19.0984715,18.6478581 16.912678,19.3994574 14.8494171,20 L21.1841339,20 L21.1841339,20 Z M21.1841339,0 C13.2575214,2.89194861 8.07672845,4 7.87150385e-14,4 L7.81597009e-14,4 L0,2 C5.74391753,2 9.9514017,1.4256397 14.8494171,1.40165657e-15 L21.1841339,6.9388939e-17 L21.1841339,0 Z M77.3787841,2.21705987e-12 C85.238555,2.9664329 90.5022896,4 100,4 L100,2 C93.1577329,2 88.6144135,1.4578092 83.604005,1.04805054e-13 L77.3787841,0 L77.3787841,2.21705987e-12 Z M7.87150385e-14,14 C8.44050043,14 13.7183277,12.7898887 22.272392,9.59832609 C22.6346445,9.46316794 23.8705367,8.99999822 24.0399055,8.9366758 C33.6397477,5.34755477 39.6469349,4 50,4 C60.2711361,4 65.3618399,5.2217689 74.6286093,8.92847669 C84.1118399,12.7217689 89.4378028,14 100,14 L100,12 C89.7288639,12 84.6381601,10.7782311 75.3713907,7.07152331 C65.8881601,3.2782311 60.5621972,2 50,2 C39.3741437,2 33.144814,3.39738661 23.3395101,7.0633242 C23.1688625,7.12712472 21.9338538,7.58996334 21.5732596,7.72450279 C13.2235239,10.8398294 8.16350991,12 0,12 L7.81597009e-14,14 L7.87150385e-14,14 L7.87150385e-14,14 Z" fill="#efe4d8" id="Combined-Shape"></path>
                    </pattern>
                    <pattern id="continentPattern" width="4" height="4" patternUnits="userSpaceOnUse">
                        <rect fill="#f0e7de" x="0" width="4" height="4" y="0"></rect>
                        <path d="M1 3h1v1H1V3zm2-2h1v1H3V1z" fill="#ddcec0" id="Combined-Shape"></path>
                    </pattern>
                </def>
            </svg>
        </div>
    }

    toggleWinds() {
        if (this.state.showWinds) {
            this.state.navigationMap.removeLayer(this.state.windLayer);
            this.setState({ showWinds: false })
        } else {
            this.state.navigationMap.addLayer(this.state.windLayer);
            this.setState({ showWinds: true })
        }
    }
    toggleLogs() {
        if (this.state.showLogs) {
            this.state.navigationMap.removeLayer(this.state.logPointsGroup);
            this.setState({ showLogs: false })
        } else {
            this.state.navigationMap.addLayer(this.state.logPointsGroup);
            this.setState({ showLogs: true })
        }
    }
    toggleCurrents() {
        if (this.state.showLogs) {
            this.state.navigationMap.removeLayer(this.state.currentsLayer);
            this.setState({ showCurrents: false })
        } else {
            this.state.navigationMap.addLayer(this.state.currentsLayer);
            this.setState({ showCurrents: true })
        }
    }

    mapZoomHandler() {
        console.log(this.state.navigationMap.getZoom())
        // setZoomLevel(this.state.map.getZoom());
        const mapZoom = this.state.navigationMap.getZoom();

        // Change base layer laŭ zoom level
        // if (mapZoom >= 10) {
        //     this.state.navigationMap.addLayer(this.state.land_lvl_4_Layer);
        //     this.state.navigationMap.removeLayer(this.state.land_lvl_2_Layer);
        //     this.state.navigationMap.removeLayer(this.state.land_lvl_3_Layer);
        //     this.state.navigationMap.removeLayer(this.state.land_lvl_1_Layer);
        // }
        if (mapZoom > 6) { // && mapZoom < 10
            this.state.navigationMap.addLayer(this.state.land_lvl_3_Layer);
            this.state.navigationMap.removeLayer(this.state.land_lvl_2_Layer);
            this.state.navigationMap.removeLayer(this.state.land_lvl_1_Layer);
            this.state.navigationMap.removeLayer(this.state.land_lvl_4_Layer);
        } else if (mapZoom < 4) {
            this.state.navigationMap.addLayer(this.state.land_lvl_1_Layer);
            this.state.navigationMap.removeLayer(this.state.land_lvl_2_Layer);
            this.state.navigationMap.removeLayer(this.state.land_lvl_3_Layer);
            this.state.navigationMap.removeLayer(this.state.land_lvl_4_Layer);
        }
        else {
            this.state.navigationMap.addLayer(this.state.land_lvl_2_Layer);
            this.state.navigationMap.removeLayer(this.state.land_lvl_1_Layer);
            this.state.navigationMap.removeLayer(this.state.land_lvl_3_Layer);
            this.state.navigationMap.removeLayer(this.state.land_lvl_4_Layer);
        }

        // Change sea labels laŭ zoom level
        if (mapZoom <= 2) {
            this.state.navigationMap.removeLayer(this.state.labelGroup_0);
            this.state.navigationMap.removeLayer(this.state.labelGroup_1);
            this.state.navigationMap.removeLayer(this.state.labelGroup_2);
            this.state.navigationMap.removeLayer(this.state.labelGroup_3);
            this.state.navigationMap.removeLayer(this.state.labelGroup_4);
            this.state.navigationMap.removeLayer(this.state.labelGroup_5);
            this.state.navigationMap.removeLayer(this.state.labelGroup_6);
            this.state.navigationMap.removeLayer(this.state.labelGroup_7);
            this.state.navigationMap.removeLayer(this.state.labelGroup_8);
            this.state.navigationMap.removeLayer(this.state.labelGroup_9);
        }
        if (mapZoom > 2 && mapZoom <= 4) {
            this.state.navigationMap.addLayer(this.state.labelGroup_0);
            this.state.navigationMap.removeLayer(this.state.labelGroup_1);
            this.state.navigationMap.removeLayer(this.state.labelGroup_2);
            this.state.navigationMap.removeLayer(this.state.labelGroup_3);
            this.state.navigationMap.removeLayer(this.state.labelGroup_4);
            this.state.navigationMap.removeLayer(this.state.labelGroup_5);
            this.state.navigationMap.removeLayer(this.state.labelGroup_6);
            this.state.navigationMap.removeLayer(this.state.labelGroup_7);
            this.state.navigationMap.removeLayer(this.state.labelGroup_8);
            this.state.navigationMap.removeLayer(this.state.labelGroup_9);
        } else if (mapZoom > 4 && mapZoom <= 5) {
            this.state.navigationMap.addLayer(this.state.labelGroup_0);
            this.state.navigationMap.addLayer(this.state.labelGroup_1);
            this.state.navigationMap.removeLayer(this.state.labelGroup_2);
            this.state.navigationMap.removeLayer(this.state.labelGroup_3);
            this.state.navigationMap.removeLayer(this.state.labelGroup_4);
            this.state.navigationMap.removeLayer(this.state.labelGroup_5);
            this.state.navigationMap.removeLayer(this.state.labelGroup_6);
            this.state.navigationMap.removeLayer(this.state.labelGroup_7);
            this.state.navigationMap.removeLayer(this.state.labelGroup_8);
            this.state.navigationMap.removeLayer(this.state.labelGroup_9);
        } else if (mapZoom > 5 && mapZoom <= 6) {
            this.state.navigationMap.addLayer(this.state.labelGroup_0);
            this.state.navigationMap.addLayer(this.state.labelGroup_1);
            this.state.navigationMap.addLayer(this.state.labelGroup_2);
            this.state.navigationMap.addLayer(this.state.labelGroup_3);
            this.state.navigationMap.addLayer(this.state.labelGroup_4);
            this.state.navigationMap.removeLayer(this.state.labelGroup_5);
            this.state.navigationMap.removeLayer(this.state.labelGroup_6);
            this.state.navigationMap.removeLayer(this.state.labelGroup_7);
            this.state.navigationMap.removeLayer(this.state.labelGroup_8);
            this.state.navigationMap.removeLayer(this.state.labelGroup_9);
        } else if (mapZoom > 6) {
            this.state.navigationMap.addLayer(this.state.labelGroup_0);
            this.state.navigationMap.addLayer(this.state.labelGroup_1);
            this.state.navigationMap.addLayer(this.state.labelGroup_2);
            this.state.navigationMap.addLayer(this.state.labelGroup_3);
            this.state.navigationMap.addLayer(this.state.labelGroup_4);
            this.state.navigationMap.addLayer(this.state.labelGroup_5);
            this.state.navigationMap.addLayer(this.state.labelGroup_6);
            this.state.navigationMap.addLayer(this.state.labelGroup_7);
            this.state.navigationMap.addLayer(this.state.labelGroup_8);
            this.state.navigationMap.addLayer(this.state.labelGroup_9);
        }
    }

    onEachFeature(feature, layer) {

    }
}
export default NavigationMap;
